import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import RouteListener from './RouteListener';
import ComprehensionQuestion from './ComprehensionQuestion';

require('../../css/components/VideoPlayerEndSlate.scss');

'use strict';

export default class VideoPlayerEndSlate extends React.Component {
    constructor(props) {
        super(props);
        this.state = { upNextCountdown: this.props.upNextCountdown };
        this.setRouterRef = this.setRouterRef.bind(this);
        this.onQuestionAsked = this.onQuestionAsked.bind(this);
        this.onQuestionAnsweredCorrectly = this.onQuestionAnsweredCorrectly.bind(this);
        this.onQuestionAnsweredIncorrectly = this.onQuestionAnsweredIncorrectly.bind(this);
    }

    componentDidMount() {
        if (this.props.nextAsset && this.props.upNextCountdown > 0)
            this.timerID = setInterval(
                () => this.tick(),
                1000
            );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    onQuestionAsked() {
        if (this.props.onQuestionAsked)
            this.props.onQuestionAsked();
    }

    onQuestionAnsweredCorrectly() {
        this.cancelCountdown();

        if (this.props.onQuestionAnsweredCorrectly)
            this.props.onQuestionAnsweredCorrectly();
    }

    onQuestionAnsweredIncorrectly() {
        this.cancelCountdown();

        if (this.props.onQuestionAnsweredIncorrectly)
            this.props.onQuestionAnsweredIncorrectly();
    }

    tick() {
        if (this.state.upNextCountdown <= 0) {
            clearInterval(this.timerID);
            this.routerRef.history.push(this.props.nextAsset.url);
        }
        else
            this.setState((prevState, props) => ({
                upNextCountdown: prevState.upNextCountdown - 1
            }));
    }

    cancelCountdown() {
        clearInterval(this.timerID);
        this.setState({ upNextCountdown: 0 });
    }

    setRouterRef(ref) {
        this.routerRef = ref;
    }

    render() {

        var question = React.createElement(
            ComprehensionQuestion,
            {
                copy: this.props.copy,
                question: this.props.question,
                answers: this.props.answers,
                correctAnswer: this.props.correctAnswer,
                onQuestionAsked: this.onQuestionAsked,
                onQuestionAnsweredCorrectly: this.onQuestionAnsweredCorrectly,
                onQuestionAnsweredIncorrectly: this.onQuestionAnsweredIncorrectly,
                answerFollowup: this.props.answerFollowup
            }
        );

        return React.createElement(
            Router,
            { ref: this.setRouterRef },
            React.createElement(
                'div',
                { className: "player-end-slate-container" },
                [
                    question,
                    React.createElement(
                        Route,
                        {
                            path: '/',
                            component: RouteListener
                        },
                    ),
                    this.props.nextAsset && this.props.showUpNext ?
                        React.createElement(
                            'div',
                            { className: "player-end-slate-next-up" },
                            [
                                React.createElement(
                                    'div',
                                    { className: "player-end-slate-heading" },
                                    "Up Next" + (this.state.upNextCountdown ? " in " + this.state.upNextCountdown: "")
                                ),
                                React.createElement(
                                    Link,
                                    { to: this.props.nextAsset.url, className: 'player-end-slate-text' },
                                    this.props.nextAsset.asset.title
                                )
                            ]
                        ) :
                        null
                ]
            )
        );
    }
}